import { createI18n } from 'vue-i18n';

import * as storage from 'store';

// const en_US = require('./en.json');
// const zh_CN = require('./zh.json');

// const en_US1 = require('./en1.json');
// const zh_CN1 = require('./zh1.json');

const messages = {
  // zh_CN: { ...zh_CN, ...zh_CN1 },
  // en_US: { ...en_US, ...en_US1 }
};

export default createI18n({
  locale: storage.get('lang') || 'zh_CN',
  fallbackLocale: storage.get('lang') || 'zh_CN',
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  messages
});
